import React from "react";
import { Plus, BriefcaseBusiness } from "lucide-react";

import Button from "../../../../components/buttons/Button";
import { EllipsisMenu } from "../../../../components/menu/ellipsis/EllipsisMenu";
import EmptyState from "../../../../components/feedback/EmptyState";

import ViewContainer from "../../../../components/layout/view/ViewContainer";

import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentPanelHeader from "../../../../components/layout/content/ContentPanelHeader";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Heading from "../../../../components/typography/Heading";
import Text from "../../../../components/typography/Text";

import { formatPeriod } from "../utils/talentUtils";

import "./TalentExperiencesView.css";

export default function TalentExperiencesView({
  experiences = [],
  onAdd,
  onEdit,
  onRemove,
  busy = false,
  readOnly = false,
}) {
  const experienceList = Array.isArray(experiences) ? experiences : [];

  return (
    <ViewContainer>
      <ContentPanel>
        <ContentPanelHeader
          title="Experience"
          subTitle="My sporting background, teams and career journey."
        >
          {!readOnly && (
            <Button
              value="Add Experience"
              icon={<Plus size={16} />}
              variant="primary-outlined"
              disabled={busy}
              onClick={onAdd}
            />
          )}
        </ContentPanelHeader>

        {!experienceList.length ? (
          <EmptyState
            icon={<BriefcaseBusiness size={28} />}
            title="No sporting experience yet"
            description={
              readOnly
                ? "Sporting experience will appear here when available."
                : "Add your teams, clubs and playing experience to build your sporting history."
            }
          />
        ) : (
          <div className="user-talent__entries">
            {experienceList.map((item) => {
              const details = [item.organisation, item.sport, item.position]
                .filter(Boolean)
                .join(" · ");

              const period = formatPeriod(
                item.startDate,
                item.endDate,
                Boolean(item.isCurrent),
              );

              return (
                <ContentItem
                  key={item.experienceId}
                  actions={
                    !readOnly && (
                      <EllipsisMenu
                        ariaLabel={`${item.title} options`}
                        position="right"
                        disabled={busy}
                        options={[
                          {
                            id: "edit",
                            label: "Edit Experience",
                            action: () => onEdit?.(item),
                          },
                          {
                            id: "delete",
                            label: "Delete Experience",
                            className: "is-danger",
                            action: () => onRemove?.(item),
                          },
                        ]}
                      />
                    )
                  }
                >
                  <Heading as="h3" size="sm">
                    {item.title}
                  </Heading>

                  {details && (
                    <Text as="p" tone="secondary" size="sm">
                      {details}
                    </Text>
                  )}

                  {period && (
                    <Text as="p" tone="secondary" size="sm">
                      {period}
                    </Text>
                  )}

                  {item.description && (
                    <Text as="p" className="user-talent__body">
                      {item.description}
                    </Text>
                  )}
                </ContentItem>
              );
            })}
          </div>
        )}
      </ContentPanel>
    </ViewContainer>
  );
}
